import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {KeyCodes} from '../../../keyCodes';
import {faAngleDown, faAngleUp} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-array',
  templateUrl: './array.component.html',
  styleUrls: ['./array.component.css']
})
export class ArrayComponent {

  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;

  @Input() entities: any[]; // List of entities in array
  @Input() selectedEntity: any; // The selected entity in array
  @Input() listColumns: { id: string, title: string }[]; // Metadata of array
  @Input() isShortcutsInUse: boolean; // Are shortcuts in use
  @Input() entityOrder: { columnId: any, ascending: boolean }; // The ordering info

  @Output() rowSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowOpenRequire: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowDeleteRequire: EventEmitter<any> = new EventEmitter<any>();
  @Output() headerClicked: EventEmitter<any> = new EventEmitter<any>();


  constructor() {
  }

  /**
   * Listener for keyboard.
   * @param event The info of pressed button.
   */
  @HostListener('window:keydown', ['$event'])
  buttonPressed(event: any): void {
    if (this.isShortcutsInUse) {
      if (event.keyCode === KeyCodes.UP_ARROW) {
        this.selectPrevious(this.selectedEntity);
      }
      if (event.keyCode === KeyCodes.DOWN_ARROW) {
        this.selectNext(this.selectedEntity);
      }
      if (event.keyCode === KeyCodes.ENTER) {
        this.rowOpenRequire.emit(this.selectedEntity);
      }
      if (event.keyCode === KeyCodes.DELETE) {
        this.rowDeleteRequire.emit(this.selectedEntity);
      }
    }
  }

  /**
   * Is the given column ordered in ascending order.
   * @param columnId The id of the column whose order is checked.
   */
  isColumnInAscendingOrder(columnId: any): boolean {
    if (!this.entityOrder || this.entityOrder.columnId !== columnId || !this.entityOrder.ascending) {
      return false;
    }
    return true;
  }

  /**
   * Is the given column ordered in descending order.
   * @param columnId The id of the column whose order is checked.
   */
  isColumnInDescendingOrder(columnId: any): boolean {
    if (!this.entityOrder || this.entityOrder.columnId !== columnId || this.entityOrder.ascending) {
      return false;
    }
    return true;
  }

  /**
   * Selects the next row to the given entity in the table. If the last row is given then
   * this function selects the first row.
   * @param entity The row next to this entity (row) is selected.
   */
  private selectNext(entity: any): void {
    let index = this.entities.indexOf(entity) + 1;
    if (this.entities.length - 1 < index) {
      index = 0;
    }
    if (this.entities.length > 0) {
      this.selectedEntity = this.entities[index];
      this.rowSelected.emit(this.selectedEntity);
    }
  }

  /**
   * Selects the previous row to the given entity in the table. If the first row is given then
   * this function selects the last row.
   * @param entity The row previous to this entity (row) is selected.
   */
  private selectPrevious(entity: any): void {
    let index = this.entities.indexOf(entity) - 1;
    if (index < 0) {
      index = this.entities.length - 1;
    }
    if (this.entities.length > 0) {
      this.selectedEntity = this.entities[index];
      this.rowSelected.emit(this.selectedEntity);
    }
  }

  /**
   * When a header has been clicked.
   * @param id The clicked header.
   */
  onHeaderClicked(id: any): void {
    this.headerClicked.emit(id);
  }

  /**
   * A row has been selected.
   * @param entity The selected row.
   */
  onSelect(entity: any): void {
    this.selectedEntity = entity;
    this.rowSelected.emit(entity);
  }

  /**
   * A row has been double clicked.
   * @param entity The entity of the row.
   */
  rowDoubleClicked(entity: any): void {
    this.rowOpenRequire.emit(entity);
  }
}
